import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgBuildingWithLoupe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 47 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.44 5.662h3.775v3.831H6.44V5.662ZM13.205 5.662h3.775v3.831h-3.775V5.662ZM6.44 12.103h3.775v3.831H6.44v-3.83ZM13.205 12.103h3.775v3.831h-3.775v-3.83ZM6.44 18.947h3.775v3.831H6.44v-3.83ZM13.205 18.947h3.775v3.831h-3.775v-3.83ZM22.358 5.662h3.775v3.831h-3.775V5.662ZM29.123 5.662H32.9v3.831h-3.776V5.662ZM22.358 12.103h3.776v3.831h-3.776zM29.123 12.103H32.9v3.831h-3.776v-3.83ZM22.358 18.947h3.776v3.831h-3.776zM29.123 18.947H32.9v3.831h-3.776v-3.83Z"
      stroke="#C2C5CC"
    />
    <mask id="building-with-loupe_svg__a" fill="#fff">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.98 22.621v10.017H22.477V26.35h-5.543v6.29H2.756V3.551H.262V0h38.63v3.552H36.98v9.424"
      />
    </mask>
    <path
      d="M36.98 32.638v1h1v-1h-1Zm-14.503 0h-1v1h1v-1Zm0-6.289h1v-1h-1v1Zm-5.543 0v-1h-1v1h1Zm0 6.29v1h1v-1h-1Zm-14.178 0h-1v1h1v-1ZM.262 3.551h-1v1h1v-1ZM.262 0v-1h-1v1h1Zm38.63 0h1v-1h-1v1Zm0 3.552v1h1v-1h-1Zm-1.912 0v-1h-1v1h1Zm-1 19.07v10.016h2V22.621h-2Zm1 9.016H22.477v2H36.98v-2Zm-13.503 1V26.35h-2v6.29h2Zm-1-7.289h-5.543v2h5.543v-2Zm-6.543 1v6.29h2v-6.29h-2Zm1 5.29H2.756v2h14.178v-2Zm-13.178 1V3.551h-2v29.086h2Zm-1-30.087H.262v2h2.494v-2Zm-1.494 1V0h-2v3.552h2ZM.262 1h38.63v-2H.261v2Zm37.63-1v3.552h2V0h-2Zm1 2.552H36.98v2h1.911v-2Zm-2.912 1v9.424h2V3.552h-2Z"
      fill="#C2C5CC"
      mask="url(#building-with-loupe_svg__a)"
    />
    <path
      clipRule="evenodd"
      d="M37.845 22.628a4.875 4.875 0 1 0 0-9.75 4.875 4.875 0 0 0 0 9.75Z"
      stroke="#C2C5CC"
    />
    <path d="m41.058 21.306 4.68 5.235" stroke="#C2C5CC" />
  </svg>
);
const Memo = memo(SvgBuildingWithLoupe);
export default Memo;
